import React, {useEffect, useState} from 'react';
import firebase from "../../firebase/firebase";

import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import {useLocation, useNavigate} from "react-router-dom";
import {styled} from "@mui/material/styles";
import TableCell, {tableCellClasses} from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import InputBase from "@mui/material/InputBase";
import TableHead from "@mui/material/TableHead";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import Button from "@mui/material/Button";
import ContactUser from "../../helpers/contact-user";
import {AuthUserContext} from "../../providers/AuthProvider";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: 'none',
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: '#F1F4F8',
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));
const BootstrapInput = styled(InputBase)(({ theme }) => ({
  'label + &': {
    marginTop: theme.spacing(3),
  },
  '& .MuiInputBase-input': {
    borderRadius: 30,
    position: 'relative',
    backgroundColor: '#204488',
    border: 'none',
    fontSize: 16,
    width: 80,
    color: '#fff',
    padding: '10px 26px 10px 12px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    '&:focus': {
      borderRadius: 30,
      borderColor: 'none',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
  },
}));
export default function UserCreatorView(){
  const location = useLocation()
  const navigator = useNavigate()
  const {profile} = React.useContext(AuthUserContext);

  const {user} = location.state;
  const [projects, setProjects] = useState([]);
  const [isLoadingUser,setLoadingUser] = React.useState(false);

  const contactUser = async () => {
    try {
      setLoadingUser(true)
      const id = await ContactUser(profile, user?.uid)
      setLoadingUser(false)
      navigator('/admin/chat')

    } catch (e) {
      setLoadingUser(false)
    }
  }
  useEffect(() => {
     
    let projectRef = firebase
      .firestore()
      .collection('projects')
      .orderBy('createdAt', 'desc')
      .where('uid', '==', user?.uid).get()
      .then((projectSnapshot) => {
         
        if (projectSnapshot?.size > 0){

          const list = []
          projectSnapshot?.docs.forEach((project)=>{
            if (project?.data().status === 'approved') {
              list.push({id: project?.id, ...project?.data()});
            }

          })
          setProjects(list)


        }
      })

  }, [])


  return(
    <Container maxWidth={'full-width'}  sx={{height: 'calc(100vh - 120px)', p: 5, textAlign: 'left', overflowY: 'scroll'}}>
      <Stack direction={'column'} spacing={5}>
        <Stack direction={'row'} spacing={3}>
          <Typography variant={'h4'} color={'primary'}>
            User
          </Typography><Typography variant={'h4'} color={'primary'}>
            >
          </Typography><Typography variant={'h4'} color={'primary'}>
            User list
          </Typography><Typography variant={'h4'} color={'primary'}>
            >
          </Typography><Typography variant={'h4'} color={'primary'}>
          {user?.name} ({user.userType})
          </Typography>
        </Stack>


        <TableContainer >
          <Table sx={{ minWidth: 700 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <StyledTableCell  sx={{fontWeight: 'bolder', fontSize:16,width:'50%' }}>Live projects</StyledTableCell>
                <StyledTableCell  sx={{fontWeight: 'bolder', fontSize:16, width:'50%'}}>Project details</StyledTableCell>
              </TableRow>
            </TableHead>
            {projects?.length == 0 ? 
              <Typography noWrap={true} sx={{ fontSize:16 , marginTop : "12px" , padding : "6px" }} >
                  No Live Projects
              </Typography> : <></> 
            }
            <TableBody>
              {projects?.length > 0 && projects.map((row) => (  <StyledTableRow
                key={row.id}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <StyledTableCell   align="left">
                  <Typography noWrap={true} >
                    {row?.title}
                  </Typography>
                </StyledTableCell>
                <StyledTableCell   align="left">
                  <Button variant={'text'} sx={{textDecoration: 'underline',}} onClick={() => navigator(`/admin/live-project-details/${row?.id}`)}>View project</Button>
                </StyledTableCell>
              </StyledTableRow>))}
            </TableBody>
          </Table>
        </TableContainer>


        <Stack direction={'row'} spacing={3}  justifyContent="center"
               alignItems="center">
          <Button onClick={() => navigator(-1)} color={'primary'} variant={'contained'}>Go back</Button>
          <Button variant={'contained'} color={'primary'} onClick={contactUser}>
            Contact user
          </Button>
        </Stack>
      </Stack>


    </Container>

    )
}